import { render } from "./StarButton.vue?vue&type=template&id=c92f5bdc&scoped=true"
import script from "./StarButton.vue?vue&type=script&lang=js"
export * from "./StarButton.vue?vue&type=script&lang=js"

import "./StarButton.vue?vue&type=style&index=0&id=c92f5bdc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92f5bdc"]])

export default __exports__